import { signUserOut } from "../SessionManagement/actionCreators"

export const mapState = (state) => ({
  userPool: state.sessionReducer.userPool,
  ssoEnabled: state.sessionReducer.ssoEnabled,
})

export const mapDispatch = (dispatch) => ({
  signUserOut: (data) => dispatch(signUserOut(data)),
})
